import { SERVICE_GROUP_ID } from '@/constants';
import { ServiceGroup } from '@/types/serviceGroup';
import React from 'react';
import styled from 'styled-components';

type Props = {
  service: ServiceGroup;
};

export const EmbaServiceEndingAnnouncement: React.FC<Props> = (props) => {
  return (
    <>
      {props.service.id === SERVICE_GROUP_ID.emba && (
        <Announcement>
          「eMBA2.0」の法人向けサービスは、eMBA2.0のリニューアルに伴い、2026年7月末にサービス提供を終了する予定です。リニューアル後の新サービスの詳細や、サービス提供終了までのスケジュールは
          <a
            href="https://globis4biz.zendesk.com/hc/ja/articles/38210729041689"
            target="_blank"
          >
            こちら
          </a>
          をご覧ください。
        </Announcement>
      )}
      {props.service.id === SERVICE_GROUP_ID.hodaiplus && (
        <Announcement>
          「eMBA2.0」と「GLOBIS
          学び放題プラス（旧）」は、eMBA2.0のリニューアルに伴い、2026年7月末にサービス提供を終了する予定です。リニューアル後の新サービスの詳細や、サービス提供終了までのスケジュールは
          <a
            href="https://globis4biz.zendesk.com/hc/ja/articles/38210729041689"
            target="_blank"
          >
            こちら
          </a>
          をご覧ください。
          <br />
          ※GLOBIS 学び放題プラス（旧）の新規申込受付は終了しました。
        </Announcement>
      )}
    </>
  );
};

const Announcement = styled.div`
  color: red;
  font-size: 14px;
  border: 1px;
  margin-bottom: 20px;
`;
